import { Box, CircularProgress, Modal } from "@mui/material";
import { useState } from "react";
import Styles from './style.module.css';
// import { setUserData } from "../redux/userSlice";
import { useDispatch } from "react-redux";
import Toastify from "../container/helper/Toastify";
import api from "../container/helper/Api";
import { setLogin } from "../container/redux/userSlice";
import { unwrapResult } from "@reduxjs/toolkit";

const OtpModal = ({ closeModal, open, desc, data }) => {
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const Data = data
  const styles = {
    position: "absolute",
    top: "0",
    left: "0",
    bgcolor: "transparent",
    border: "none",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    "&:focus": {
      outline: "none",
    },
  };

  const handleSubmit = async () => {
    if (otp.length === 4) {
      try {
        setIsLoading(true)
        const { data, status } = await api.confirmUpdateProfile({ OTP: otp, ...Data })

        if (status === 200) {
          const res = await dispatch(setLogin(data?.data?.data))
          await unwrapResult(res);
          Toastify.success("Profile Updated Successfully")
          setOtp("")
          closeModal()
        }
      } catch (error) {
        Toastify.error(error.response.data.message || `something went wrong`);
        setOtp("")
      }
      finally {
        setIsLoading(false)
      }
    } else {
      console.log("not clicked");
    }
  };

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styles}>
        <div className={Styles.otpContainer}>
          <div
            className={Styles.entryView}
            style={{
              paddingLeft: 20,
              paddingRight: 20,
              flexDirection: "column",
            }}
          >
            <div className={Styles.headingText} style={{ textAlign: "center" }}>
              Enter Your OTP
            </div>

            <div className={Styles.lineStyle} style={{ width: "100%" }} />
            {desc && (

              <div className={Styles.descStyle}>
                {/* We have sent you an OTP to your vy***@gmail.com, please check and verify. */}
                {desc}

              </div>
            )}

            <input
              type="text"
              placeholder="Enter 4-digit OTP..."
              value={otp}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,4}$/.test(input)) setOtp(input); // Only allows up to 4 digits
              }}
              className={Styles.otpInput}
            />

            <div className={Styles.buttons}>
              <div onClick={closeModal} className={Styles.cancelStyle}>
                Cancel
              </div>
              {/* <div
            //   onClick={otp.length === 4 ? handleSubmit : null}
             onClick={() => {
                handleSubmit();
              }}
              className={`${Styles.deleteStyle} ${
                otp.length !== 4 ? Styles.disabled : ""
              }`}
              style={{
                cursor: otp.length === 4 ? "pointer" : "not-allowed",
                opacity: otp.length === 4 ? 1 : 0.6,
              }}
            > */}
              <div
                onClick={() => {
                  handleSubmit();
                }}
                className={`${Styles.deleteStyle}`}
                style={{
                  cursor: otp.length === 4 ? "pointer" : "not-allowed",
                  opacity: otp.length === 4 ? 1 : 0.6,
                }}
              >
                {isLoading ? <CircularProgress size="30px" color="inherit" /> : `Submit`}
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default OtpModal;
